import React from 'react';
import { DashboardCard } from './DashboardCard';
import { BadgeIcon, WifiIcon, SignalIcon, GlobeIcon, BarChart4Icon, PieChartIcon, ZapIcon, BatteryFullIcon, SettingsIcon, InfoIcon } from 'lucide-react';
export function SubscriptionOverview() {
  // Mock data
  const subscriptionData = {
    active: 991,
    inactive: 348,
    pending: 80,
    total: 1419
  };
  const subscriptionTypes = [{
    name: 'iCRcell',
    active: 932,
    inactive: 244,
    total: 1176
  }, {
    name: 'iTRACKcell',
    active: 65,
    inactive: 0,
    total: 65
  }, {
    name: 'iCRwl',
    active: 357,
    inactive: 0,
    total: 357
  }, {
    name: 'iCPUMPv1',
    active: 4,
    inactive: 0,
    total: 4
  }, {
    name: 'iCPUMP',
    active: 10,
    inactive: 0,
    total: 10
  }];
  const regionSubscriptions = [{
    name: 'Aisco MENA',
    active: 10,
    inactive: 5,
    total: 15
  }, {
    name: 'Aisco AFRICA',
    active: 20,
    inactive: 8,
    total: 28
  }, {
    name: 'Aisco EUROPE',
    active: 820,
    inactive: 250,
    total: 1070
  }, {
    name: 'Aisco AMERICA',
    active: 180,
    inactive: 95,
    total: 275
  }, {
    name: 'Aisco LATAM',
    active: 160,
    inactive: 90,
    total: 250
  }, {
    name: 'Aisco ANZ',
    active: 150,
    inactive: 85,
    total: 235
  }];
  return <div className="space-y-6" data-id="element-1776">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1777">
        <DashboardCard icon={<BadgeIcon size={20} className="text-blue-400" data-id="element-1779" />} title="Subscription Summary" data-id="element-1778">
          <div className="flex flex-col" data-id="element-1780">
            <div className="flex justify-between items-start mb-6" data-id="element-1781">
              <div data-id="element-1782">
                <div className="text-5xl font-bold text-white" data-id="element-1783">
                  {subscriptionData.total}
                </div>
                <div className="text-sm text-blue-300 mt-2" data-id="element-1784">
                  Total Subscriptions
                </div>
              </div>
              <div className="flex items-center space-x-4" data-id="element-1785">
                <div className="flex items-center" data-id="element-1786">
                  <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-1787"></div>
                  <span className="text-sm text-blue-300" data-id="element-1788">Active</span>
                </div>
                <div className="flex items-center" data-id="element-1789">
                  <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-1790"></div>
                  <span className="text-sm text-blue-300" data-id="element-1791">Inactive</span>
                </div>
              </div>
            </div>
            <div className="relative h-48" data-id="element-1792">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-1793">
                <div className="relative w-40 h-40" data-id="element-1794">
                  <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-1795">
                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#334155" strokeWidth="15" data-id="element-1796" />
                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#3b82f6" strokeWidth="15" strokeDasharray={`${subscriptionData.active / subscriptionData.total * 251.2} 251.2`} transform="rotate(-90 50 50)" data-id="element-1797" />
                  </svg>
                  <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1798">
                    <div className="text-3xl font-bold text-white" data-id="element-1799">
                      {subscriptionData.active}
                    </div>
                    <div className="text-sm text-blue-300" data-id="element-1800">active</div>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 text-lg text-blue-300" data-id="element-1801">
                <div className="flex items-center" data-id="element-1802">
                  <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-1803"></div>
                  <span data-id="element-1804">{subscriptionData.inactive}</span>
                </div>
              </div>
              <div className="absolute bottom-0 right-0 text-lg text-blue-300" data-id="element-1805">
                <div className="flex items-center" data-id="element-1806">
                  <div className="w-3 h-3 rounded-full bg-amber-500 mr-1" data-id="element-1807"></div>
                  <span data-id="element-1808">{subscriptionData.pending}</span>
                </div>
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<WifiIcon size={20} className="text-blue-400" data-id="element-1810" />} title="Subscription Types" data-id="element-1809">
          <div className="space-y-6" data-id="element-1811">
            {subscriptionTypes.map((type, index) => <div key={index} className="space-y-2" data-id="element-1812">
                <div className="flex justify-between items-center" data-id="element-1813">
                  <div className="text-lg font-medium text-white" data-id="element-1814">
                    {type.name}
                  </div>
                  <div className="text-sm text-blue-300" data-id="element-1815">
                    {type.active} active
                    {type.inactive > 0 ? ` / ${type.inactive} inactive` : ''}
                  </div>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1816">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${type.active / 1000 * 100}%`
              }} data-id="element-1817"></div>
                </div>
                <div className="text-xs text-blue-300 text-right" data-id="element-1818">
                  {type.active} of {type.total}
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-1820" />} title="Regional Distribution" data-id="element-1819">
        <div className="flex justify-end mb-6" data-id="element-1821">
          <div className="flex items-center space-x-4" data-id="element-1822">
            <div className="flex items-center" data-id="element-1823">
              <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-1824"></div>
              <span className="text-sm text-blue-300" data-id="element-1825">Active</span>
            </div>
            <div className="flex items-center" data-id="element-1826">
              <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-1827"></div>
              <span className="text-sm text-blue-300" data-id="element-1828">Inactive</span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1829">
          {regionSubscriptions.map((region, index) => <div key={index} className="bg-slate-800/50 rounded-lg p-4" data-id="element-1830">
              <div className="flex justify-between items-center mb-3" data-id="element-1831">
                <div className="text-lg font-medium text-white" data-id="element-1832">
                  {region.name}
                </div>
                <div className="text-sm text-blue-300" data-id="element-1833">{region.total}</div>
              </div>
              <div className="space-y-2" data-id="element-1834">
                <div className="flex justify-between items-center" data-id="element-1835">
                  <span className="text-xs text-blue-300" data-id="element-1836">Active</span>
                  <span className="text-xs text-white" data-id="element-1837">{region.active}</span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-1838">
                  <div className="bg-blue-500 h-1.5 rounded-full" style={{
                width: `${region.active / region.total * 100}%`
              }} data-id="element-1839"></div>
                </div>
                <div className="flex justify-between items-center" data-id="element-1840">
                  <span className="text-xs text-blue-300" data-id="element-1841">Inactive</span>
                  <span className="text-xs text-white" data-id="element-1842">{region.inactive}</span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-1843">
                  <div className="bg-slate-600 h-1.5 rounded-full" style={{
                width: `${region.inactive / region.total * 100}%`
              }} data-id="element-1844"></div>
                </div>
              </div>
            </div>)}
        </div>
      </DashboardCard>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1845">
        <DashboardCard icon={<SettingsIcon size={20} className="text-blue-400" data-id="element-1847" />} title="Subscription Map" data-id="element-1846">
          <div className="relative h-80 bg-slate-900 rounded-lg overflow-hidden flex items-center justify-center" data-id="element-1848">
            <div className="text-blue-400 text-lg" data-id="element-1849">
              Map visualization will be displayed here
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<ZapIcon size={20} className="text-blue-400" data-id="element-1851" />} title="Subscription Status" data-id="element-1850">
          <div className="space-y-6" data-id="element-1852">
            <div className="flex justify-center" data-id="element-1853">
              <div className="relative w-40 h-40" data-id="element-1854">
                <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-1855">
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#0c4a6e" strokeWidth="15" data-id="element-1856" />
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#22d3ee" strokeWidth="15" strokeDasharray="251.2 251.2" strokeDashoffset="230" transform="rotate(-90 50 50)" data-id="element-1857" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1858">
                  <div className="text-5xl font-bold text-cyan-300" data-id="element-1859">1</div>
                  <div className="text-sm text-blue-300" data-id="element-1860">Pending</div>
                </div>
              </div>
            </div>
            <div className="bg-slate-800/50 rounded-lg p-4" data-id="element-1861">
              <div className="text-lg font-medium text-white mb-3" data-id="element-1862">
                Premium Subscriptions
              </div>
              <div className="space-y-4" data-id="element-1863">
                <div className="space-y-2" data-id="element-1864">
                  <div className="flex justify-between items-center" data-id="element-1865">
                    <span className="text-sm text-blue-300" data-id="element-1866">iCRcell</span>
                    <span className="text-sm text-white" data-id="element-1867">688 active</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-1868">
                    <div className="bg-blue-500 h-2 rounded-full" style={{
                    width: '70%'
                  }} data-id="element-1869"></div>
                  </div>
                  <div className="text-xs text-blue-300 text-right" data-id="element-1870">
                    688 active / 244 inactive
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1871">
                  <div className="flex justify-between items-center" data-id="element-1872">
                    <span className="text-sm text-blue-300" data-id="element-1873">iCRwl</span>
                    <span className="text-sm text-white" data-id="element-1874">357 active</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-1875">
                    <div className="bg-cyan-500 h-2 rounded-full" style={{
                    width: '35%'
                  }} data-id="element-1876"></div>
                  </div>
                  <div className="text-xs text-blue-300 text-right" data-id="element-1877">
                    357 active / 0 inactive
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DashboardCard>
      </div>
    </div>;
}